/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.service('ColorService', ["$rootScope", "$http", function ($rootScope, $http) {

        var colors = {
            "freePositionField":"light-green lighten-2",
            "minePositionFieldApproved": "orange lighten-2",
            "minePositionFieldNotApproved": "yellow lighten-2",
            "minePositionFieldFromAdmin": " amber lighten-2",
            "otherPositionFieldApproved": "red lighten-2",
            "otherPositionFieldNotApproved": "yellow lighten-2"            
        }
        var getColor = function(name)
        {
            color = colors[name]
            
            return color;
        }

        return {
            getColor: getColor
        };

    }]);